.lineHeader {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: var(--mantine-spacing-sm);
    padding: var(--mantine-spacing-md);
    background-color: var(--mantine-color-gray-0);
    border-bottom: 1px solid var(--mantine-color-gray-2);
}

.lineBody {
    display: flex;
    flex-direction: column;
    gap: var(--mantine-spacing-sm);
    padding: var(--mantine-spacing-md);
}

.statusDot {
    flex: 0 0 auto;
    width: 10px;
    height: 10px;
    margin-top: 6px;
    border-radius: 50%;
}

.statusDotMapped {
    background-color: var(--mt-signal-info);
}

.statusDotUnmapped {
    background-color: var(--mt-signal-attention-5);
}

.requirementRow {
    display: flex;
    align-items: center;
    gap: var(--mantine-spacing-sm);
    padding-left: var(--mantine-spacing-sm);
    border-left: 2px solid var(--mantine-color-gray-3);
}

.iconChip {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    color: var(--mantine-color-gray-7);
    background-color: var(--mantine-color-gray-0);
    border: 1px solid var(--mantine-color-gray-3);
    border-radius: var(--mantine-radius-md);
}

.typeSelect {
    flex: 1;
    min-width: 180px;
}

.controls {
    display: flex;
    flex: 0 0 auto;
    align-items: center;
    gap: var(--mantine-spacing-xs);
}
